'use strict';

const clientSideValidation = require('./components/clientSideValidation');
const emailValidation = require('./components/emailValidation');
const fileAttachment = require('./components/fileAttachment');
const supportCommon = require('./components/supportCommon');

// tabの初期表示 readonly属性の追加
function initDefaultActive() {
    // 指定されたタブの取得
    const tabName = $('#tabdata').data('tab');
    if (tabName) {
        $('.jsUnderlineParts').addClass('notransition');
        $('.jsTabToggleButton#' + tabName).trigger('click');
        resetForms(tabName);
        setTimeout(() => {
            $('.jsUnderlineParts').removeClass('notransition');
        }, 300);
    } else {
        resetForms('generalQuestion');
        $('.jsTabToggleButton#myOrder').trigger('click');
    }
}

// 指定されたform以外をリセット
function resetForms(tabName) {
    supportCommon.resetFormsExcept(tabName, fileAttachment, clientSideValidation);
}


const keydownHandler = function (e) {
    if (e.keyCode == 27) {
        $content.find('.btn-close').click();
        return false;
    }
};

/**
 * Display popup collaboration request 's Term and Condition
 * @param {closeBtnUrl} closeBtnUrl - Close button image url
 * @param {form} form - Form that will be submitted
 */
function popupCollaborationRequestDialog(closeBtnUrl, form) {
    $.spinner().stop();
    $.magnificPopup.open({
        items: {
            src: '#collaboration-request-modal',
            type: 'inline'
        },
        settings: null,
        closeOnBgClick: true,
        mainClass: 'mfp-fade',
        removalDelay: 600,
        closeMarkup: '<button title="Close (Esc)" type="button" class="mfp-close mfp-close--custom btn-close" onclick="$.magnificPopup.close();"><img src="' + closeBtnUrl + '"></button>',
        callbacks: {
            open: function() {
                var $content = $(this.content);

                $content.off('click').on('click', '.btn-close', function() {
                    $.magnificPopup.close();
                    $(document).off('keydown', keydownHandler);
                });


                $content.off('click').on('click', '.button-continue', function() {
                    const modal = $('#collaboration-request-modal');
                    modal.spinner().start();
                    form.trigger('submit');
                    $(document).on('keydown', keydownHandler);
                });

                $(document).on('keydown', keydownHandler);
            },
            close: function() {
                $(document).off('keydown', keydownHandler);
                $('.button-collaboration-submit').prop('disabled', false);
            }
        }
    });
}

$(() => {
    // 重複バインド防止：既にsupport処理が初期化されている場合はスキップ
    if (window.supportInitialized) {
        console.warn('⚠️  Support handlers already initialized, skipping support.js');
        return;
    }
    window.supportInitialized = true;

    // タブの切り替え時にformをリセット タイトルを変更
    $('.jsTabToggleButton').on('click', function(e) {
        const tabName = $(this).attr('id');
        resetForms(tabName);
        let title = supportCommon.SUPPORT_CONFIG.TAB_NAMES[tabName];
        $('.main-content__ttl').text(title);
    });

    initDefaultActive();
    
    // ファイル添付機能を初期化
    fileAttachment.initializeFileAttachment();

    // submit buttonを押した時のvalidation（重複バインド防止）
    $('.button-support-submit').off('click.support').on('click.support', function(e) {
        $(this).prop('disabled', true);
        $.spinner().start();
        e.preventDefault();

        const form = $(this).closest('form');
        let isCustomValid = true;

        // エラーメッセージの除去
        clientSideValidation.functions.clearForm(form.get(0));
        
        // emailの正規表現チェック
        let email = form.find('#email');
        if (!emailValidation(email.val())) {
            email.addClass('is-invalid');
            email.parents('.form-group').find('.invalid-feedback').text(email.data('pattern-mismatch'));
            isCustomValid = false;
        }
        // ファイルの添付チェック
        const fileValidation = supportCommon.validateFileAttachment(form);
        if (!fileValidation.isValid) {
            const file = form.find('.jsAttacheFile');
            file.addClass('is-invalid');
            file.parents('.form-group').find('.invalid-feedback').text(fileValidation.errorMessage);
            isCustomValid = false;
        } 

        var isValid = clientSideValidation.functions.validateForm(form.get(0));

        if (isCustomValid && isValid) {
            form.trigger('submit');
        } else {
            $(this).prop('disabled', false);
            $.spinner().stop();
        }
    });

    // Collaboration RequestのSubmitボタンを押した時のvalidation
    $('.button-collaboration-submit').on('click', function(e) {
        $(this).prop('disabled', true);
        $.spinner().start();
        e.preventDefault();

        const form = $(this).closest('form');
        let isCustomValid = true;

        // エラーメッセージの除去
        clientSideValidation.functions.clearForm(form.get(0));
        
        // emailの正規表現チェック
        let email = form.find('#email');
        if (!emailValidation(email.val())) {
            email.addClass('is-invalid');
            email.parents('.form-group').find('.invalid-feedback').text(email.data('pattern-mismatch'));
            isCustomValid = false;
        }
        
        var isValid = clientSideValidation.functions.validateForm(form.get(0));

        if (!isCustomValid || !isValid) {
            $(this).prop('disabled', false);
            $.spinner().stop();
            return;
        }

        var closeBtnUrl = $(this).data('close-btn');
        popupCollaborationRequestDialog(closeBtnUrl, form);
    });


    // formをajaxで送信したときの処理（重複バインド防止）
    $('form').off('submit.support').on('submit.support', function(e) {
        e.preventDefault();
        const form = $(this)
        const url = form.attr('action');

        // formDataの作成
        let formData = new FormData();
        formData.append('formData', JSON.stringify(form.serializeArray()));
        formData.append(form.find('.csrf').data('name'), form.find('.csrf').data('token'));
        formData.append('tab', form.attr('class'));

        // ファイルの追加
        const fileResult = supportCommon.processFileAttachment(formData, form, fileAttachment);
        
        if (!fileResult.success) {
            console.error('❌ File attachment failed:', fileResult.errors);
            // ファイル添付失敗時のエラーハンドリングを追加
            const errorHtml = '<div class="myaccount-information-error-message">' + 
                '<p>File attachment failed. Please try again.</p>' + '</div>';
            $('.backend-error-message').html(errorHtml);
            
            // スピナーを停止してボタンを再有効化
            $('form').find('.button-support-submit').prop('disabled', false);
            $.spinner().stop();
            return false;
        }
        
        if (fileResult.fileCount > 0) {
            console.log(`📎 Attached ${fileResult.fileCount} files for upload`);
        }

        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: formData,
            processData: false,
            contentType: false,
            success(data) {
                if (data.success) {
                    location.href = data.redirectUrl;
                } else if (data.validateResult) {
                    // Display errors on fields with name
                    data.validateResult.forEach((field) => {
                        if(!field.valid) {
                            let $invalidField = form.find(`[name="${field.name}"]`);
                            $invalidField.addClass('is-invalid');
                            $invalidField.parents('.form-group').find('.invalid-feedback').text($invalidField.data(field.error) || field.error);
                        }
                    });
                    form.find('.button-support-submit').prop('disabled', false);
                    $.spinner().stop();
                } else {
                    const errorHtml = '<div class="myaccount-information-error-message">' + '<p>' + data.error + '</p>' + '</div>';
                    $('.backend-error-message').html(errorHtml);
                    form.find('.button-support-submit').prop('disabled', false);
                    $.spinner().stop();
                }
            },
            error(data) {
                if (data.responseJSON.redirectUrl) {
                    window.location.href = data.responseJSON.redirectUrl;
                }
            }
        });
    });

});
